import { parseProductCode } from '@webdev/product-code';
import { RatePlan, RatePlanConfig } from './makeRatePlanCapacities';

export type ProductRatePlanConfig = Pick<RatePlanConfig, 'productRatePlans_Enscape'>;
export const isEnscapeRatePlan = (
  ratePlan: Pick<RatePlan, 'productRatePlanId' | 'ProductCode__c'>,
  config?: ProductRatePlanConfig,
) => {
  const isLegacyRatePlan = config?.productRatePlans_Enscape.some((enscapeProductRatePlan) => {
    return ratePlan.productRatePlanId === enscapeProductRatePlan.id;
  });
  if (isLegacyRatePlan) {
    return true;
  }
  const { ProductCode__c } = ratePlan;
  if (!ProductCode__c) {
    return false;
  }
  const { productFamily } = parseProductCode(ProductCode__c);
  return productFamily === 'EN';
};
